import "core-js";

import * as $ from "jquery";

import CustomElements from "./CustomElements";
import Blackout from "./Components/Blackout";
import MobileNav from "./Components/MobileNav";

CustomElements.add("ge-modal");

$(document).ready(function() {
	console.log("Ready!");

	Blackout.initialize($("#blackout"));

	let nav = new MobileNav(
		$(".toggle-off-canvas"),
		$(".mobile-off-canvas")
	);
});